import { faPhone, faEnvelope, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "react-bootstrap";
import bluePurpleBackground from "../Images/bluePurpleBackground.png"
import Logo from "../Images/logo.png";



export const Footer = () => {
    return (
        <>
            <Container
                fluid
                style={{
                    backgroundImage: `url(${bluePurpleBackground})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    position: 'relative',
                    padding: '3rem 0',
                    color: '#fff',
                }}
            >
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.6)', // Dark overlay
                        zIndex: 1,
                    }}
                />

                <Row
                    className="align-items-start text-center text-md-start"
                    style={{ position: 'relative', zIndex: 2 }}
                >
                    {/* Logo and Description Section */}
                    <Col
                        xs={12}
                        md={3}
                        className="d-flex flex-column align-items-center mb-4" // Align center for all screen sizes
                    >
                        <div
                            className="logoBackground"
                            style={{
                                backgroundColor: 'white',
                                padding: '2rem',
                                borderRadius: '8px',
                                boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.1)',
                                textAlign: 'center',
                            }}
                        >
                            <img src={Logo} alt="Logos" style={{ width: '70%', height: 'auto' }} />
                        </div>
                        <p
                            style={{
                                maxWidth: '70%',
                                textAlign: 'center',
                                marginTop: '1rem',
                                fontSize: '0.9rem',
                                color: '#dcdcdc',
                            }}
                        >
                            Logos Brokers is an approved licensed financial services provider as registered with the
                            Financial Sector Conduct Authority, FSP number: 15026
                        </p>
                    </Col>

                    {/* Contact Details Section */}
                    <Col xs={12} md={4} className="mb-4">
                        <h5 style={{ marginBottom: '1rem', color: '#f8f9fa' }}>Contact Details</h5>
                        <p style={{ fontSize: '1rem' }}>
                            <FontAwesomeIcon icon={faPhone} style={{ marginTop: '0.7rem' }} /> &nbsp;073 878 4875
                            <br />
                            <FontAwesomeIcon icon={faEnvelope} style={{ marginTop: '0.7rem' }} /> &nbsp; info@logosbrokers.co.za
                            <br />
                            <FontAwesomeIcon icon={faMapMarkerAlt} style={{ marginTop: '0.7rem' }} /> &nbsp; 70 Union Ave, Centurion, 0157
                        </p>
                    </Col>

                    {/* Legal Links Section */}
                    <Col xs={12} md={3}>
                        <h5 style={{ marginBottom: '1rem', color: '#f8f9fa' }}>Legal Information</h5>
                        <p style={{ fontSize: '1rem' }}>
                            <a
                                href="/LegalInformation"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#dcdcdc', textDecoration: 'none' }}
                            >
                                Legal Documents
                            </a>
                            <br />
                            <a
                                href="/Documents/PrivacyPolicy.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#dcdcdc', textDecoration: 'none' }}
                            >
                                Privacy Policy
                            </a>
                            <br />
                            <a
                                href="Documents/WebsiteTermsandConditions.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#dcdcdc', textDecoration: 'none' }}
                            >
                                Terms & Conditions
                            </a>
                            <br />
                            <a
                                href="Documents/WebsiteDisclaimer.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#dcdcdc', textDecoration: 'none' }}
                            >
                                Disclaimer
                            </a>
                        </p>
                    </Col>
                </Row>

                {/* Footer Bottom Section */}
                <Row
                    style={{
                        borderTop: '1px solid rgba(255, 255, 255, 0.3)',
                        paddingTop: '1rem',
                        textAlign: 'center',
                    }}
                >
                    <Col>
                        <p style={{ fontSize: '0.9rem', color: '#dcdcdc' }}>
                            © 2025 Logos Brokers. All rights reserved.
                        </p>
                    </Col>
                </Row>
            </Container>
        </>
    )
};